// Must run before the Supabase client is imported anywhere, so we can read the
// auth hash before detectSessionInUrl consumes and strips it.
import "./lib/authHashCapture";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
